<template>
  <div class="DashboardMetrics">
    <Card :title="$t('business.total')" class="DashboardMetrics__Total">
      <CounterDisplay :value="metrics.totalBusinesses" icon="target" />
      <LineChartDisplay :options="options" :series="series" />
    </Card>
    <Card :title="$t('business.new')">
      <CounterDisplay :value="metrics.newBusinesses" icon="new" class="icon" />
      <LineChartDisplay :options="options" :series="series" />
    </Card>
  </div>
</template>

<script>
import { Icon } from 'daas-components';

import { getBusinessMetrics } from '@/api';

import { Card, CounterDisplay, LineChartDisplay } from '@/components';

export default {
  name: 'DashboardMetrics',
  components: {
    Icon,
    Card,
    CounterDisplay,
    LineChartDisplay,
  },
  data() {
    return {
      metrics: {},
      series: [
        {
          name: this.$t('business'),
          data: [12, 1, 20, 8, 15, 18, 2, 6, 12, 1, 20, 8, 15, 18, 2, 6],
        },
      ],
      options: {
        sectors: [],
        chart: {
          toolbar: {
            show: false,
          },
        },
        grid: {
          show: false,
        },
        xaxis: {
          labels: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
        },
      },
    };
  },
  created() {
    getBusinessMetrics().then(
      data => {
        this.metrics = data;
      },
      err => {
        console.log('Fetch Error: ', err);
      }
    );
  },
};
</script>

<style lang="scss">
.DashboardMetrics {
  display: flex;
  justify-content: center;
  .Card {
    width: rem(400);
    max-width: rem(500);
    margin: rem(10);
  }
}
</style>
